var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2914 7.66618L10.6126 9.61702L8.31472 10.1786L8.33019 13.0516L1.36949 8.39994C0.853256 8.0545 0.713379 7.35322 1.05867 6.83657L4.65867 1.4496C5.0037 0.933226 5.70526 0.793349 6.2219 1.13904L11.5266 4.68382L11.4845 7.21507L10.2914 7.66618ZM5.63524 2.01772C5.60281 1.99601 5.55845 2.00497 5.53688 2.03739L3.66828 4.8334L2.59237 6.44297L1.93694 7.42388C1.91605 7.45617 1.92432 7.50012 1.95702 7.52197L7.26319 11.0683L7.25518 9.55883L9.38347 8.65186L9.10847 6.98444L10.4404 6.48054L10.4606 5.24171L5.63524 2.01772Z",
    fill: "#D32029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8574 1.83305L19.0918 7.91398L19.092 7.91391C19.3061 8.49783 19.0057 9.14649 18.4223 9.36099L15.4159 10.4654L12.9726 8.70486L13.9346 6.62513L12.1946 5.8472L12.5711 4.43009L10.5273 2.95775L15.4104 1.1639C15.9939 0.949668 16.6425 1.24979 16.8574 1.83305ZM13.7781 3.9975L13.4461 5.24977L15.1882 6.02894L14.3533 8.39804L15.5784 9.28031L18.0575 8.36929C18.0947 8.35613 18.1134 8.31543 18.0998 8.27839L17.6931 7.17088L17.0254 5.35396L15.8658 2.19766C15.852 2.1609 15.8114 2.14231 15.7748 2.15547L12.7591 3.26378L13.7781 3.9975Z",
    fill: "#D32029"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroken);
export default __webpack_public_path__ + "static/media/broken.255ed833ed68f35691fdb5d3ea2037f8.svg";
export { ForwardRef as ReactComponent };